import Vue from 'vue';
import upperFirst from 'lodash.upperfirst';
import camelCase from 'lodash.camelcase';

// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.
const modules = import.meta.glob('../components/base/base-*.vue', { eager: true });

Object.entries(modules).forEach(([fileName, componentConfig]) => {
	const componentName = upperFirst(
		camelCase(
			fileName
				.replace(/^.*\//, '')  // strip directory
				.replace(/\.\w+$/, '') // strip extension
		)
	);
  // console.log(`Registering Vue component: ${componentName}`);
	Vue.component(componentName, componentConfig.default || componentConfig);
});